<template>
  <div class="qr-code-scanner">
    <video ref="scan" playsinline></video>
  </div>
</template>

<script>
  const Instascan = require('instascan');

  export default {
    name: "QRCodeScanner",

    data() {
      return {
        scanner: null
      };
    },
    methods: {
      scanQrCode() {
        this.$nextTick()
          .then(() => {
            this.scanner = new Instascan.Scanner({video: this.$refs.scan});
            this.scanner.addListener('scan', (content) => {
              this.$emit('codeScanned', content)
                      });
            Instascan.Camera.getCameras().then((cameras) => {
              if (cameras.length > 0) {
                let camera = cameras.find(c => c.name.indexOf('back') !== -1 || c.name.indexOf('Back') !== -1);
                if (!camera) {
                  camera = cameras[0];
                }
                this.scanner.start(camera);
              } else {
                console.error('No cameras found.');
              }
            }).catch(function (e) {
              console.error(e);
            });
          })
      },

    },
    created() {
      console.log('createdddd');
      this.scanQrCode();
    },

    beforeDestroy() {
      try {
        this.scanner.stop()
      } catch (ex) {

      }
    }
  }
</script>

<style lang="scss">
  @import "QRCodeScanner";
</style>
